/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_SalesInputs */

const en_gc_home_sales = /** @type {(inputs: Gc_Home_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales dashboard`)
};

const zh_gc_home_sales = /** @type {(inputs: Gc_Home_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售看板`)
};

/**
* | output |
* | --- |
* | "Sales dashboard" |
*
* @param {Gc_Home_SalesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_sales = /** @type {((inputs?: Gc_Home_SalesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_SalesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_sales(inputs)
	return zh_gc_home_sales(inputs)
});
export { gc_home_sales as "gc.home.sales" }